import { useEffect } from "react";
import { useAppDispatch } from "../../common/store";
import { setIsNudgeOpen } from "../../common/store/app-state/app-state-slice";
import { setReqNudgeType } from "../../common/store/chat/chat-slice";
import { RequestNudgeType } from "../utils/request-nudge-type";

const useChangeUrl = () => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    const handleClick = (event: MouseEvent) => {
      let target = event.target as HTMLAnchorElement;
      target = target.tagName === 'A' ? target : target.closest('a') as HTMLAnchorElement;

      if (target && target.tagName === 'A' && target.hasAttribute('href')) {
        const href = target.href;
        const currentHref = window.location.href.split('?')[0];
        const isChanged = href.split('?')[0] !== currentHref;
        if (isChanged) {
          dispatch(setIsNudgeOpen(false));
          dispatch(setReqNudgeType(RequestNudgeType.NEW_PAGE_VISIT))
        }
      }
    };

    document.addEventListener('click', handleClick, true);
    return () => {
      document.removeEventListener('click', handleClick, true);
    };
  }, []);
}

export default useChangeUrl;
